import type { WidgetConfig, WidgetPanelSize } from '@cartiq/shared';

export const DEFAULT_WIDGET_CONFIG: WidgetConfig = {
  position: 'bottom-right',
  launcherLabel: 'Chat with us',
  showLauncherLabel: true,
  panelSize: 'standard',
  bottomOffset: 24,
};

export const WIDGET_PANEL_WIDTHS: Record<WidgetPanelSize, number> = {
  compact: 360,
  standard: 400,
  wide: 460,
};

export function resolveWidgetConfig(config?: Partial<WidgetConfig>): WidgetConfig {
  return { ...DEFAULT_WIDGET_CONFIG, ...config };
}
